export var PlayerState;
(function (PlayerState) {
    PlayerState[PlayerState["IDLE"] = 1] = "IDLE";
    PlayerState[PlayerState["PLAYING"] = 2] = "PLAYING";
    PlayerState[PlayerState["PAUSED"] = 3] = "PAUSED";
    PlayerState[PlayerState["STOPPED"] = 4] = "STOPPED";
    PlayerState[PlayerState["ERROR"] = 5] = "ERROR";
})(PlayerState || (PlayerState = {}));
